import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef, useRef, createContext } from 'react';
import { themed } from '@indeed/ifl-css';
import { mergeRefs } from '../../utils/mergeRefs.js';
import { jsx } from '@emotion/react';

const FileUploadCardListContext = /*#__PURE__*/createContext({
  listRef: {
    current: undefined
  }
});
const StyledFileUploadCardList = /*#__PURE__*/themed("ul", process.env.NODE_ENV === "production" ? {
  target: "ef9rrxd0"
} : {
  target: "ef9rrxd0",
  label: "StyledFileUploadCardList"
})(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 1,
  alignItems: "stretch",
  padding: 0,
  margin: 0,
  inlineSize: "100%",
  marginBlockStart: 1
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZpbGVVcGxvYWRDYXJkTGlzdC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZ0JpQyIsImZpbGUiOiJGaWxlVXBsb2FkQ2FyZExpc3QudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7XG4gIGNyZWF0ZUNvbnRleHQsXG4gIGZvcndhcmRSZWYsXG4gIFByb3BzV2l0aENoaWxkcmVuLFxuICBSZWZPYmplY3QsXG4gIHVzZVJlZlxufSBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCB7IFN0eWxlUHJvcHMsIHRoZW1lZCB9IGZyb20gXCJAaW5kZWVkL2lmbC1jc3NcIjtcbmltcG9ydCB7IG1lcmdlUmVmcyB9IGZyb20gXCIuLi8uLi91dGlscy9tZXJnZVJlZnNcIjtcblxudHlwZSBGaWxlVXBsb2FkQ2FyZExpc3RQcm9wcyA9IFByb3BzV2l0aENoaWxkcmVuPFN0eWxlUHJvcHM+O1xuXG5leHBvcnQgY29uc3QgRmlsZVVwbG9hZENhcmRMaXN0Q29udGV4dCA9IGNyZWF0ZUNvbnRleHQ8e1xuICBsaXN0UmVmOiBSZWZPYmplY3Q8SFRNTFVMaXN0RWxlbWVudCB8IHVuZGVmaW5lZD47XG59Pih7IGxpc3RSZWY6IHsgY3VycmVudDogdW5kZWZpbmVkIH0gfSk7XG5cbmNvbnN0IFN0eWxlZEZpbGVVcGxvYWRDYXJkTGlzdCA9IHRoZW1lZChcInVsXCIpPEZpbGVVcGxvYWRDYXJkTGlzdFByb3BzPigoKSA9PiAoe1xuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgZmxleERpcmVjdGlvbjogXCJjb2x1bW5cIixcbiAgZ2FwOiAxLFxuICBhbGlnbkl0ZW1zOiBcInN0cmV0Y2hcIixcbiAgcGFkZGluZzogMCxcbiAgbWFyZ2luOiAwLFxuICBpbmxpbmVTaXplOiBcIjEwMCVcIixcbiAgbWFyZ2luQmxvY2tTdGFydDogMVxufSkpO1xuXG5leHBvcnQgY29uc3QgRmlsZVVwbG9hZENhcmRMaXN0ID0gZm9yd2FyZFJlZjxcbiAgSFRNTFVMaXN0RWxlbWVudCxcbiAgRmlsZVVwbG9hZENhcmRMaXN0UHJvcHNcbj4oKHByb3BzLCByZWYpID0+IHtcbiAgY29uc3QgaW50ZXJuYWxSZWYgPSB1c2VSZWY8SFRNTFVMaXN0RWxlbWVudD4obnVsbCk7XG4gIGNvbnN0IG1lcmdlZFJlZiA9IG1lcmdlUmVmcyhpbnRlcm5hbFJlZiwgcmVmKTtcblxuICByZXR1cm4gKFxuICAgIDxGaWxlVXBsb2FkQ2FyZExpc3RDb250ZXh0LlByb3ZpZGVyIHZhbHVlPXt7IGxpc3RSZWY6IGludGVybmFsUmVmIH19PlxuICAgICAgPFN0eWxlZEZpbGVVcGxvYWRDYXJkTGlzdCByZWY9e21lcmdlZFJlZn0gey4uLnByb3BzfSB0YWJJbmRleD17LTF9IC8+XG4gICAgPC9GaWxlVXBsb2FkQ2FyZExpc3RDb250ZXh0LlByb3ZpZGVyPlxuICApO1xufSk7XG5cbkZpbGVVcGxvYWRDYXJkTGlzdC5kaXNwbGF5TmFtZSA9IFwiRmlsZVVwbG9hZENhcmRMaXN0XCI7XG4iXX0= */");
const FileUploadCardList = /*#__PURE__*/forwardRef((props, ref) => {
  const internalRef = useRef(null);
  const mergedRef = mergeRefs(internalRef, ref);
  return jsx(FileUploadCardListContext.Provider, {
    value: {
      listRef: internalRef
    }
  }, jsx(StyledFileUploadCardList, _extends({
    ref: mergedRef
  }, props, {
    tabIndex: -1
  })));
});
FileUploadCardList.displayName = "FileUploadCardList";

export { FileUploadCardList, FileUploadCardListContext };
